"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Participant = void 0;
const index_1 = require("./Base/index");
/**
 * Describes a BPMN Participant of a Collaboration.
 */
class Participant extends index_1.BaseElement {
}
exports.Participant = Participant;
//# sourceMappingURL=Participant.js.map